import React from 'react';

interface FeatureCardWithImageProps {
  title: string;
  description: string | React.ReactNode;
  imageUrl: string;
  imageAlt?: string;
  maxWidth?: string;
  titleColor?: string;
  titleSize?: string;
  titleWeight?: string;
  descriptionSize?: string;
  descriptionWeight?: string;
  descriptionLeading?: string;
  imageSize?: string;
  gap?: string;
}

const FeatureCardWithImage: React.FC<FeatureCardWithImageProps> = ({
  title,
  description,
  imageUrl,
  imageAlt = 'Feature image',
  maxWidth = 'max-w-[480px]',
  titleColor = 'text-[#5bb960]',
  titleSize = 'text-[16px] md:text-[20.1px]',
  titleWeight = 'font-semibold',
  descriptionSize = 'text-[14px] md:text-[16px]',
  descriptionWeight = 'font-normal',
  descriptionLeading = 'leading-[1.3]',
  imageSize = 'w-16 h-16 md:w-24 md:h-24',
  gap = 'gap-4 md:gap-12'
}) => {
  return (
    <div className={`font-open-sauce ${maxWidth} flex items-start justify-between ${gap}`}>
      <img 
        src={imageUrl} 
        alt={imageAlt}
        className={`${imageSize} object-cover flex-shrink-0`}
      />
      <div className="flex-1 max-w-[420px]">
        <p className={`font-open-sauce ${titleColor} ${titleSize} ${titleWeight}`}>
          {title}
        </p>
        <p className={`font-open-sauce ${descriptionLeading} ${descriptionSize} ${descriptionWeight}`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeatureCardWithImage;